import React, {
    useState
} from 'react';


import HeaderUno
    from '../Metodos/Compartidos/HeaderUno';

import HeaderDos
    from '../Metodos/Compartidos/HeaderDos';


import SeleccionarActividadesSeleccionadas
    from './SeleccionarActividadesSeleccionadas';

import SeleccionarActividadesDisponibles
    from './SeleccionarActividadesDisponibles';

import SeleccionarActividadesAgendadas
    from './SeleccionarActividadesAgendadas';


// css
import {
    Cuerpo
} from '../Css/StyledHeader';


import {

    ContenedorActividadesDomicilio,
    TabsActividades,
    TabActividad,
    PanelActividades

} from '../Css/StyledActividadesDomicilio';



const SeleccionarActividades = () => {


    const [
        actividad,
        setActividad
    ] = useState(
        'disponible'
    );


    return (

        <Cuerpo>


            <HeaderUno />


            <HeaderDos

                link={
                    `/escritorio/pacientes/paciente`
                }

                componente={
                    "Ejercitación Domicilio"
                }

                paciente={
                    true
                }

            />


            <ContenedorActividadesDomicilio>


                <TabsActividades>


                    <TabActividad

                        type="button"

                        activo={
                            actividad ===
                            'disponible'
                        }

                        onClick={
                            () =>
                                setActividad(
                                    'disponible'
                                )
                        }

                    >

                        Todas las Actividades

                    </TabActividad>


                    <TabActividad

                        type="button"

                        activo={
                            actividad ===
                            'seleccionada'
                        }

                        onClick={
                            () =>
                                setActividad(
                                    'seleccionada'
                                )
                        }

                    >

                        Actividades seleccionadas

                    </TabActividad>


                    <TabActividad

                        type="button"

                        activo={
                            actividad ===
                            'agendada'
                        }

                        onClick={
                            () =>
                                setActividad(
                                    'agendada'
                                )
                        }

                    >

                        Actividades Agendadas

                    </TabActividad>


                </TabsActividades>


                <PanelActividades>


                    {
                        actividad ===
                        "disponible"
                            ?
                            <SeleccionarActividadesDisponibles />
                            :
                            null
                    }


                    {
                        actividad ===
                        "seleccionada"
                            ?
                            <SeleccionarActividadesSeleccionadas />
                            :
                            null
                    }


                    {
                        actividad ===
                        "agendada"
                            ?
                            <SeleccionarActividadesAgendadas />
                            :
                            null
                    }


                </PanelActividades>


            </ContenedorActividadesDomicilio>


        </Cuerpo>

    );

};


export default SeleccionarActividades;